module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux/node_modules/symbol-observable/index.js
// module id = 716
// module chunks = 0